// extracted by css-extract-rspack-plugin
export default {"loadingBanner":"_97e59cc5"};